module.exports = __webpack_public_path__ + "static/media/3_r_vaza_43.96_90.09.5cc52dd6.png";